import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { HorizontalList } from "../../../../Constant";
import { HORIZONTAL_DATA, HORIZONTAL_LIST, HORIZONTAL_LIST_DATA } from "../../../../Data/UiKit/Lists";
import { LI, UL } from "../../../../AbstractElements";

const HorizontalLists = () => {
  return (
    <Col xl="6" sm="12" className="box-col-6">
      <Card className="height-equal">
        <CommonCardHeader title={HorizontalList} span={HORIZONTAL_DATA} />
        <CardBody>
          <div className="horizontal-list-wrapper dark-list">
            <UL className="fw-bold list-group-horizontal-sm pb-2">
              <LI className="border-left-primary">Product</LI>
              {HORIZONTAL_LIST_DATA.map((item, index) => (
                <LI key={index}>{item}</LI>
              ))}
            </UL>
            {HORIZONTAL_LIST.map(({ item, color }, index) => (
              <UL className="fw-bold list-group-horizontal-sm pb-2" key={index}>
                {item.map((data, index) => (
                  <LI className={`border-left-${index === 0 ? `${color}` : ""}`} key={index}>{data}</LI>
                ))}
              </UL>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default HorizontalLists;
